module.exports = __webpack_public_path__ + "img/waigaoqiao.5a8b6d69.png";